import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Chip, ChipGroup } from 'common/components/Chip';
import { FormSection } from 'common/components/FormSection';
import { IOfferEventDetailFragment } from 'graphql/types';

interface IProps {
    groupEnrollmentCounts: IOfferEventDetailFragment['groupEnrollmentCounts'];
}

export const GroupConditionEnrollmentsSection = ({
    groupEnrollmentCounts,
}: IProps) => {
    const [translate] = useTranslation();

    return (
        <Box sx={{ my: { xs: -2, sm: -3 } }}>
            <FormSection
                defaultExpanded
                sx={{ borderBottom: 'none' }}
                title={translate(
                    'offerEventDetail.groupConditions.groupEnrollmentsTitle'
                )}
            >
                <Stack spacing={1} sx={{ mt: 1 }}>
                    {groupEnrollmentCounts.map((enrollmentCount) => {
                        const { group, min, max, count } = enrollmentCount;

                        const notMetMinEnrollments = count < min;

                        const spotsLeftTranslation = translate(
                            !!max
                                ? 'offerEventDetail.groupConditions.spotsLeft'
                                : 'offerEventDetail.groupConditions.spotsLeft_noMax',
                            {
                                count: count,
                                max: !!max ? max : undefined,
                            }
                        );

                        return (
                            <Box
                                key={group.id}
                                sx={{
                                    display: 'flex',
                                    alignItems: {
                                        xs: 'flex-start',
                                        sm: 'center',
                                    },
                                    justifyContent: 'space-between',
                                    flexDirection: {
                                        xs: 'column',
                                        sm: 'row',
                                    },
                                }}
                            >
                                <Typography>{group.name}</Typography>

                                <ChipGroup>
                                    {!!min && notMetMinEnrollments && (
                                        <Chip
                                            label={translate(
                                                'offerEventDetail.groupConditions.minEnrollmentsAmount',
                                                {
                                                    min,
                                                }
                                            )}
                                        />
                                    )}
                                    <Chip
                                        bgColor={
                                            notMetMinEnrollments
                                                ? 'error'
                                                : 'success'
                                        }
                                        label={spotsLeftTranslation}
                                    />
                                </ChipGroup>
                            </Box>
                        );
                    })}
                </Stack>
            </FormSection>
        </Box>
    );
};
